export { default } from "./CurricUnitModal";
